// Rich Text Editor Styles - exported as JavaScript variables for use with Material UI sx prop

import { __SWEEP_DESIGN_TYPOGRAPHY_STYLES___, colors } from '@sweep-io/sweep-design';

export const editorHeadingStyles = {
  h1: {
    ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___.h1,

    margin: 0,
  },
  h2: {
    ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___.h2,
    margin: 0,
  },
  h3: {
    ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___.h3,
    margin: 0,
  },
  h4: {
    ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___.h4,
    margin: 0,
  },
  h5: {
    ...__SWEEP_DESIGN_TYPOGRAPHY_STYLES___.h5,
    margin: 0,
  },
} as const;

const editorTextStyles = {
  bold: {
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
  underline: {
    textDecoration: 'underline',
  },
} as const;

export const editorLinkStyles = {
  color: colors.blue[500],
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: colors.blue[600],
  },
} as const;

const editorParagraphStyles = {
  margin: 0,
  padding: 0,
} as const;

// Shared content styles for both editor and viewer
export const sharedContentStyles = {
  // Paragraph styles
  '& p': editorParagraphStyles,
  // Heading styles
  '& h1': editorHeadingStyles.h1,
  '& h2': editorHeadingStyles.h2,
  '& h3': editorHeadingStyles.h3,
  '& h4': editorHeadingStyles.h4,
  '& h5': editorHeadingStyles.h5,
  // Text formatting styles
  '& strong, & b': editorTextStyles.bold,
  '& em, & i': editorTextStyles.italic,
  '& u': editorTextStyles.underline,
  // Link styles
  '& a': editorLinkStyles,
  // List styles
  '& ul, & ol': {
    margin: '0 0 8px 0',
    paddingLeft: '20px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  // List item styles
  '& li': {
    listStylePosition: 'outside',
    '& ul, & ol': {
      margin: '4px 0',
      paddingLeft: '20px',
    },
  },
  // Hide bullet on list items that contain nested lists (only show the deepest bullet)
  '& li:has(> ul), & li:has(> ol)': {
    listStyle: 'none',
  },
  // Ensure nested lists have proper bullet styles for the deepest items
  '& ul': {
    listStyleType: 'disc',
    '& ul': {
      listStyleType: 'circle',
      '& ul': {
        listStyleType: 'square',
      },
    },
  },
} as const;
